// extracted by mini-css-extract-plugin
module.exports = {"root":"_0Y7A","firstList":"_1A5Wm","secondList":"_8DRdx","listLink":"zfb4n"};